module.exports = __webpack_public_path__ + "static/media/Rubik-Light.0b1bf7ea.woff2";